import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CustomerListPageComponent } from './pages/customers/customer-list-page/customer-list-page.component';
import { OrderListPageComponent } from './pages/orders/order-list-page/order-list-page.component';
import { AccountListPageComponent } from './pages/accounts/account-list-page/account-list-page.component';
import { MainComponent } from './pages/system/main/main.component';
import { AuthGuard } from './auth-guard';
import { NotFoundComponent } from './pages/system/not-found/not-found.component';
import { LoginPageComponent } from './pages/auth/login-page/login-page.component';
import { ForgotPasswordPageComponent } from './pages/auth/forgot-password-page/forgot-password-page.component';
import { AuthorizeComponent } from './pages/auth/authorize/authorize.component';
import { CustomerPageComponent } from './pages/customers/customer-page/customer-page.component';
import { ProductListPageComponent } from './pages/products/product-list-page/product-list-page.component';
import { CreateOrderPageComponent } from './pages/orders/create-order-page/create-order-page.component';
import { OrderPageComponent } from './pages/orders/order-page/order-page.component';
import { AccountPageComponent } from './pages/accounts/account-page/account-page.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { TaskListPageComponent } from './pages/tasks/task-list-page/task-list-page.component';
import { MyTasksPageComponent } from './pages/tasks/my-tasks-page/my-tasks-page.component';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'forgot-password', component: ForgotPasswordPageComponent },
  { path: "authorize", component: AuthorizeComponent },
  {path: '', component: MainComponent, children: [
    { path: 'dashboard', component: DashboardComponent },
    { path: 'customers/:id', component: CustomerPageComponent },
    { path: 'customers', component: CustomerListPageComponent },
    { path: 'orders', component: OrderListPageComponent },
    { path: 'orders/create-orders', component: CreateOrderPageComponent },
    { path: 'orders/:id', component: OrderPageComponent },
    { path: 'accounts', component: AccountListPageComponent },
    { path: 'accounts/:id', component: AccountPageComponent },
    { path: 'products', component: ProductListPageComponent },
    {
      path: 'tasks', component: TasksComponent, children: [
        { path: '', redirectTo: 'list', pathMatch: 'full' },
        { path: 'list', component: TaskListPageComponent },
        { path: ':userId', component: MyTasksPageComponent },
    ]}
  ],
  canActivate: [AuthGuard]},
  { path: "**", component: NotFoundComponent} 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
